import React, {Component} from 'react'
import PropTypes from 'prop-types';
import { Segment, Icon, Label, Button, Grid } from 'semantic-ui-react';
import { ACCOUNT_APP_ADD_VEHICLE, accountAppUrl } from '../../../modules/accountApp';

const noBorderStyle ={ 'borderStyle': 'none' };

const clickable ={ 'display': 'block' };

const AddVehicleLink = (props) => {
    return ([
        <Segment key={0} secondary disabled attached textAlign='center'>
            <a href={accountAppUrl(ACCOUNT_APP_ADD_VEHICLE)} style={clickable}>
                <Icon size='huge' name='add circle' color='grey'/>
            </a>
        </Segment>,
        <Segment key={1} attached disabled secondary attached='bottom' textAlign='center'>
            <strong>Add another vehicle</strong>
        </Segment>
    ]);
};

export default AddVehicleLink
